import React from "react";

const chats = [
  {
    id: 1,
    lastMsg: "Zasto si mi poslao ovo?",
    name: "Marija 1",
    selectChat: "private1",
    time: "00:45 AM",
  },
  {
    id: 2,
    lastMsg: "Sto mi saljes ovako kasno?",
    name: "Marija 2",
    selectChat: "private2",
    time: "00:45 AM",
  },
  {
    id: 3,
    lastMsg: "Koja si ti budala!",
    name: "Marija 3",
    selectChat: "private3",
    time: "00:46 AM",
  },
  {
    id: 4,
    lastMsg: "NE DOLAZIS?",
    name: "Marija 4",
    selectChat: "private4",
    time: "00:47 AM",
  },
  {
    id: 5,
    lastMsg: "IZNERVIRAO SI ME!",
    name: "Marija 5",
    selectChat: "private5",
    time: "00:48 AM",
  },
  {
    id: 6,
    lastMsg: "UZASAN SI!",
    name: "Marija 6",
    selectChat: "private6",
    time: "00:49 AM",
  },
  {
    id: 7,
    lastMsg: "Ma opusteno. Je l dolazis na orijentaciju danas u 14h?",
    name: "Marija 7",
    selectChat: "private7",
    time: "09:44 AM",
  },
  {
    id: 8,
    lastMsg: "Super! Vidimo se! 😊",
    name: "Marija 8",
    selectChat: "private8",
    time: "09:55 AM",
  },
  {
    id: 9,
    lastMsg: "Opusteno. Bilo je super!",
    name: "Marija 9",
    selectChat: "private9",
    time: "15:35 PM",
  },
  {
    id: 9,
    lastMsg: "Dodjii",
    name: "Group 1",
    selectChat: "group1",
    time: "02:45 PM",
  },
  {
    id: 10,
    lastMsg: "Sve ce se saznati veceras",
    name: "Group 2",
    selectChat: "group2",
    time: "06:49 PM",
  },
];

export default function AllChats({ onChangeChat }) {
  return (
    <div className="chat-app" id="chat-app">
      <div className="all-chats">
        <header className="chat-header">
          <span className="chat-name">Chats</span>
        </header>

        {chats.map((chat) => {
          const { id, lastMsg, name, selectChat, time } = chat;

          return (
            <div
              key={id}
              className="message-box"
              onClick={() => onChangeChat(selectChat)}
            >
              <div className="message-header">
                <span className="sender-name">{name}</span>
                <span className="message-time">{time}</span>
              </div>
              <div className="message-text">{lastMsg}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
